<script setup lang="ts">
import { computed, ref } from 'vue'
import { IconFont } from '@mp/component'
import Detail from './detail.vue'
import WujieVue from 'wujie-vue3'
import TabTodo from './TabTodo.vue'
import TabSystem from './TabSystem.vue'
import { messageRecordReadStatusStats, recordAllMarkRead } from '@mp/api/sdpMessage/MessageV2Controller.ts'
import { useMutation, useQuery } from '@tanstack/vue-query'

const { bus } = WujieVue
const visible = ref<boolean>(false)
const tabActive = ref<1 | 2 | 3>(1)
const detailRef = ref<InstanceType<typeof Detail>>()

// #查询消息数量
const { data: messageStats, refetch: refetchReadStatusStats } = useQuery({
  queryKey: ['message/record/read-status-stats'],
  queryFn: () => messageRecordReadStatusStats({
    targetAppId: 'WEB_B',
  }),
  select: res => res.series?.filter(item => Boolean(item.messageType)),
})

// ?获取待办的消息数量
const todoTaskStats = computed(() => {
  return messageStats.value?.find(item => item.messageType === 'todo_task')
})

// ?获取系统通知
const systemStats = computed(() => {
  return messageStats.value?.find(item => item.messageType === 'system_notification')
})

// #全部已读
const { mutate: handleMarkAllRead, isLoading: isAllReadLoading } = useMutation({
  mutationFn: recordAllMarkRead,
  onSuccess: () => {
    refetchReadStatusStats()
  },
})

function handleAllRead() {
  handleMarkAllRead({
    messageType: tabActive.value === 1 ? 'todo_task' : 'system_notification',
    targetAppId: 'WEB_B',
  })
}

bus.$on('notice:open', ({ tab }: { tab?: 1 | 2 | 3 } = {}) => {
  if (tab)
    tabActive.value = tab
  visible.value = true
})

bus.$on('notice:view', (id: string) => {
  detailRef.value?.open({ id })
})

bus.$on('notice:detail:close', () => {
  refetchReadStatusStats()
})

defineExpose({
  open() {
    visible.value = true
  },
})
</script>

<template>
  <el-drawer v-model="visible" title="消息中心" append-to-body destroy-on-close :size="750" class="text-n-800">
    <!-- <pre class="pre-code-container" title="todoTaskStats">{{ messageStats }}</pre> -->
    <div class=" relative">
      <el-button v-if="(tabActive === 1 && todoTaskStats?.unreadCount) || (tabActive === 2 && systemStats?.unreadCount)" :loading="isAllReadLoading" link class=" absolute top-[8px] right-0 cursor-pointer z-10" @click="handleAllRead">
        <IconFont
          type="icon-yidu" class=" leading-none mr-1 -translate-y-0.2
        "
        /> 全部已读
      </el-button>

      <el-tabs v-model="tabActive">
        <el-tab-pane :name="1">
          <TabTodo />

          <template #label>
            <el-badge :show-zero="false" :value="todoTaskStats?.unreadCount" :offset="[10, 0]">
              待办事项
            </el-badge>
          </template>
        </el-tab-pane>
        <el-tab-pane label="系统通知" :name="2">
          <TabSystem />

          <template #label>
            <el-badge :is-dot="Boolean(systemStats?.unreadCount)" :offset="[5, 0]">
              系统通知
            </el-badge>
          </template>
        </el-tab-pane>
        <!-- <el-tab-pane label="平台公告" :name="3">
          <div v-for="item in 10" :key="item">
            <Item @view="handleView" />
          </div>
          <template #label>
            <el-badge is-dot :offset="[5, 0]">
              平台公告
            </el-badge>
          </template>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </el-drawer>

  <Detail ref="detailRef" />
</template>
